exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".invoice-operation .operation-buttons .operation-group[data-v-37ebbb2d]{display:-webkit-box;display:-ms-flexbox;display:flex}.invoice-operation .operation-buttons .operation-link[data-v-37ebbb2d]{color:#1890ff;cursor:pointer;text-decoration:none;font-size:14px}.invoice-operation .operation-buttons .operation-link[data-v-37ebbb2d]:hover{color:#40a9ff;text-decoration:underline}.invoice-operation .operation-buttons .operation-link+.operation-link[data-v-37ebbb2d]{margin-left:8px}", ""]);

// exports
